/** When your routing table is too long, you can split it into small modules**/

import InspectSuperviseHome from  '@/components/inspectSuperviseHome'

const supervise = {
  path: '/inspectSuperviseHome',
  name: 'inspectSuperviseHome',
  redirect:{path:'/inspectSuperviseHome/HOME/supervise'},
  meta: {supervise: true},
  component: InspectSuperviseHome,
  children: [
    {
      path: 'HOME/:type',
      component: () => import('@/views/inspectDraw/business/configuration/home'),
      name: 'DrawHOME',
    },
    // {
    //   path: '/inspectSupervise/drawManage',
    //   component: ()=>import('@/views/inspectSupervise/maintain/drawManage/list'),
    //   name: 'inspectSuperviseDrawManage',
    // },
    {
      path: '/inspectSupervise/taskMaintenance',
      component: () => import('@/views/inspectSupervise/maintain/task/list'),
      name: 'inspectSuperviseTaskMaintenance',
    },{
      path: '/inspectSupervise/detail',
      component: () => import('@/views/inspectSupervise/maintain/task/details'),
      name: 'inspectSuperviseDetail',
    },
    {
      path: '/inspectSupervise/procedure',
      component: () => import('@/views/inspectSupervise/maintain/task/procedure'),
      name: 'inspectSuperviseProcedure',
    },
    {
      path: '/inspectSupervise/drawMessage',
      component: ()=>import('@/views/inspectSupervise/maintain/drawMessage/list'),
      name: 'inspectSuperviseDrawMessage',
    },
    {
      path: '/inspectSupervise/comment',
      component: () => import('@/views/inspectSupervise/maintain/comment/list'),
      name: 'inspectSuperviseComment',
    },{
      path: '/inspectSupervise/reportInfo',
      component: () => import('@/views/inspectSupervise/maintain/report/info'),
      name: 'inspectSuperviseReportInfo',
    },{
      path: '/inspectSupervise/reportView',
      component: () => import('@/views/inspectSupervise/maintain/report/view'),
      name: 'inspectSuperviseReportView',
    },{
      path: '/inspectSupervise/restPassword',
      component: () => import('@/views/inspectSupervise/maintain/config/rest_password'),
      name: 'inspectSuperviserestPassword',
    },{
      path: '/inspectSupervise/drawConfig',
      component: () => import('@/views/inspectSupervise/maintain/configuration/config'),
      name: 'inspectSuperviseDrawConfig',
    },{
      path: '/inspectSupervise/drawProfessional',
      component: () => import('@/views/inspectSupervise/maintain/configuration/professional'),
      name: 'inspectSuperviseDrawProfessional',
    },{
      path: '/inspectSupervise/drawNotice',
      component: () => import('@/views/inspectSupervise/maintain/configuration/notice'),
      name: 'inspectSuperviseDrawNotice',
    },{
      path: '/inspectSupervise/drawDesignAudit',
      component: () => import('@/views/inspectSupervise/maintain/configuration/designAudit'),
      name: 'inspectSuperviseDrawDesignAudit',
    },{
      path: '/inspectSupervise/drawDesignList',
      component: () => import('@/views/inspectSupervise/maintain/configuration/designList'),
      name: 'inspectSuperviseDrawDesignList',
    },{
      path: '/inspectSupervise/infoConstruction',
      component: () => import('@/views/inspectSupervise/maintain/information/construction'),
      name: 'infoConstruction',
    },{
      path: '/inspectSupervise/infoDesign',
      component: () => import('@/views/inspectSupervise/maintain/information/design'),
      name: 'infoDesign',
    },{
      path: '/inspectSupervise/Designset',
      component: () => import('@/views/inspectSupervise/maintain/information/design_set'),
      name: 'Designset',
    },{
      path: '/inspectSupervise/infoItemtype',
      component: () => import('@/views/inspectSupervise/maintain/information/itemtype'),
      name: 'infoItemtype',
    },{
      path: '/inspectSupervise/infoPolicy',
      component: () => import('@/views/inspectSupervise/maintain/information/policy'),
      name: 'infoPolicy',
    },{
      path: '/inspectSupervise/infoStrong',
      component: () => import('@/views/inspectSupervise/maintain/information/strong'),
      name: 'infoStrong',
    },{
      path: '/inspectSupervise/reportExamine',
      component: () => import('@/views/inspectSupervise/business/reportExamine/list'),
      name: 'reportExamine',
    },{
      path: '/inspectSupervise/editTask',
      component: () => import('@/views/inspectSupervise/business/reportExamine/editTask'),
      name: 'editTask1',
    },
    {
      path: '/inspectSupervise/greenBa',
      component: () => import('@/views/inspectDraw/business/reportExamine/greenBul'),
      name: 'greenBa1',
      meta: {title : '绿建审查汇总'}
    },
    {
      path: '/inspectSupervise/supervise_compact',
      component: () => import('@/views/common/task/supervise_compact'),
      name: 'inspectSupervise_supervise_compact',
      meta: {title : '监管合同管理',},
    },
    {
      path: '/inspectSupervise/noticeConfig',
      component: () => import('@/views/inspectSupervise/maintain/configuration/noticeConfig'),
      name: 'noticeConfig',
    },
    {
      path: '/inspectSupervise/greenConstrction',
      component: () => import('@/views/inspectSupervise/maintain/greenForm/greenConstrction'),
      name: 'greenConstrction',
    },
    {
      path: '/inspectSupervise/greenList',
      component: () => import('@/views/inspectSupervise/maintain/greenForm/greenList'),
      name: 'greenList',
    },
    {
      path: '/inspectSupervise/locationList', //按所属区域绿色建筑设计标准统计
      component: () => import('@/views/inspectSupervise/maintain/greenForm/locationList'),
      name: 'locationList',
    },
    {
      path: '/inspectSupervise/censortKindList',//按审查机构绿色建筑项目类型统计
      component: () => import('@/views/inspectSupervise/maintain/greenForm/censortKindList'),
      name: 'censortKindList',
    },
    {
      path: '/inspectSupervise/standardList',//标准查询
      component: () => import('@/views/inspectSupervise/maintain/greenForm/standardList'),
      name: 'standardList',
    },
    {
      path: '/inspectSupervise/censorShipList',//审查机构查询
      component: () => import('@/views/inspectSupervise/maintain/greenForm/censorShipList'),
      name: 'censorShipList',
    },
    {
      path: '/inspectSupervise/locationKindList',//按所属区域绿色建筑项目类型统计
      component: () => import('@/views/inspectSupervise/maintain/greenForm/locationKindList'),
      name: 'locationKindList',
    },
    {
      path: '/inspectSupervise/projectKind',//按所属区域绿色建筑项目类型统计
      component: () => import('@/views/inspectSupervise/maintain/greenForm/projectKind'),
      name: 'projectKind',
    },
    {
      path: '/inspectSupervise/proportion',//按所属区域绿色建筑项目类型统计
      component: () => import('@/views/inspectSupervise/maintain/greenForm/proportion'),
      name: 'proportion',
    },{
      path: '/inspectSupervise/tablearea',
      component: () => import('@/views/common/task/tablearea'),
      name: 'inspectTablearea',
    },{
      path: '/inspectSupervise/report',
      component: () => import('@/views/inspectDraw/maintain/report/list'),
      name: 'report',
    },{
      path: '/inspectSupervise/select',
      component: () => import('@/views/inspectDraw/business/taskChange/select'),
      name: 'select',
    },{
      path: '/inspectSupervise/taskRevert',
      component: () => import('@/views/inspectDraw/business/taskQuery/revert'),
      name: 'taskQueryRervert',
    },{
      path: '/inspectSupervise/userMaintenance',
      component: () => import('@/views/inspectDraw/maintain/userMaintenance/list'),
      name: 'userMaintenance',
    },{
      path: '/inspectSupervise/regionInfo',
      component: () => import('@/views/inspectDraw/maintain/regioninfo/list'),
      name: 'regionInfo',
    },{
      path: '/inspectSupervise/administration',
      component: () => import('@/views/inspectDraw/maintain/administration/list'),
      name: 'administration',
    },{
      path: '/inspectSupervise/customerEdit',
      component: () => import('@/views/inspectDraw/business/customer/edit'),
      name: 'customerEdit',
    },{
      path: '/inspectSupervise/customerInfoList',
      component: () => import('@/views/inspectDraw/maintain/customerinfo/list'),
      name: 'customerInfoList',
    },{
      path: '/inspectSupervise/configList',
      component: () => import('@/views/inspectDraw/maintain/config/list'),
      name: 'configList',
    },{
      path: '/inspectSupervise/formConfig/list',
      component: () => import('@/views/inspectDraw/maintain/formConfig/list'),
      name: 'formConfigList',
    },{
      path: '/inspectSupervise/drawManage',
      component: ()=>import('@/views/inspectDraw/business/task/drawManage'),
      name: 'drawManage',
    },
    {
      path: '/inspectSupervise/drawManage/detail',
      component: ()=>import('@/views/inspectDraw/business/task/manageDetail'),
      name: 'inspectSupervisemanageDetail',
    },
    {
      path: '/inspectSupervise/supervise_compact',
      component: () => import('@/views/common/task/supervise_compact'),
      name: 'inspectDraw_supervise_compact',
      meta: {title : '图审合同管理',},
    },{
      path: '/inspectSupervise/drawMessage',
      component: ()=>import('@/views/inspectDraw/maintain/drawMessage/list'),
      name: 'drawMessage',
    },{
      path: '/inspectSupervise/spotCheck',
      component: ()=>import('@/views/inspectDraw/maintain/drawMessage/spotCheck'),
      name: 'drawSpotcheck',
    },{
      path: '/inspectSupervise/config',
      component: () => import('@/views/inspectDraw/maintain/config/config'),
      name: 'config',
    },{
      path: '/inspectSupervise /formConfig/edit',
      component: () => import('@/views/inspectDraw/maintain/formConfig/edit'),
      name: 'formConfigEdit',
    },
    {
      path: '/inspectSupervise/systemaudit',
      component: () => import('@/views/inspectSupervise/maintain/comment/systemaudit'),
      name: 'inspectSupervisesystemaudit',
    },
    {
      path: '/inspectSupervise/chargegs',
      component: ()=>import('@/views/inspectSupervise/maintain/drawMessage/chargegs'),
      name: 'inspectSupervisechargegs',
    },
  ]
};

export default supervise



// WEBPACK FOOTER //
// ./src/router/supervise/index.js